// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__2vce1","total":"Cart_total__3p8eh","actions":"Cart_actions__2BXAN","button--alt":"Cart_button--alt__dkeej","button":"Cart_button__1dzss"};